import { isConnectCtrol, getUUID } from './connectWidget/common';
import store from '@/store';
const { state } = store;
const { print: printState } = state;

export function checkCtrolOpen(contrlType, needTipsMessage, isMultiTemplate) {
  if (isMultiTemplate) {
    return true;
  }

  switch (contrlType) {
    case 'CLODOP':
      return isConnectCtrol(this, 'CLODOP', { isMultiTemplate, needTipsMessage });
    case 'CN':
      return isConnectCtrol(this, 'CN', { isMultiTemplate, needTipsMessage });
    case 'PDD':
      return isConnectCtrol(this, 'PDD', { isMultiTemplate, needTipsMessage });
    case 'FXG':
      return isConnectCtrol(this, 'FXG', { isMultiTemplate, needTipsMessage });
    case 'JD':
      return isConnectCtrol(this, 'JD', { isMultiTemplate, needTipsMessage });
    case 'KS':
      return isConnectCtrol(this, 'KS', { isMultiTemplate, needTipsMessage });
  }
}

export function checkPrinterList(contrlType, callback) {
  setTimeout(() => {
    if (getListData(contrlType)) {
      callback && callback(true);
    } else {
      checkPrinterList(contrlType, callback);
    }
  }, 100);
}
export function getListData(contrlType) {
  return printState.widget[contrlType].printerList;
}
export function getPrintersFromControl(contrlType, requestParams, config = {}) {
  const { needTipsMessage, isMultiTemplate, callback, socket } = config;
  requestParams = requestParams || { cmd: 'getPrinters', requestID: getUUID(8, 16), version: '1.0' };
  if (checkCtrolOpen(contrlType, needTipsMessage, isMultiTemplate)) {
    if (!getListData(contrlType)) {
      socket && socket.send(JSON.stringify(requestParams));
    }
    checkPrinterList(contrlType, callback);
  } else {
    callback(false);
  }
}

export function getPrinterDataByLodop() {
  const LODOP = window.getLodop();
  let printerList = [];
  if (LODOP) {
    const counter = LODOP.GET_PRINTER_COUNT(); // 获取打印机个数
    for (let i = 0; i < counter; i++) {
      printerList.push({
        name: LODOP.GET_PRINTER_NAME(i),
        label: LODOP.GET_PRINTER_NAME(i),
        value: i,
      });
    }
  }
  return printerList;
}
